import _ from "lodash";
import {
  Component,
} from "react";
import {
  getInnerText,
  isReactElement,
} from "CommonCore/util";
import exportTable from "CommonCore/export-table";
import moment from "moment";

export default class ReportBase extends Component {

}

export function exportReport(rowData, headerData) {
  const rows = [];
  report2plain(rowData, rows);

  let fileBaseName = "Lehraufträge";
  fileBaseName = fileBaseName + moment().format("-YYYYMMDD-HHmmss");
  exportTable("excel", fileBaseName, headerData, rows);
}

export function report2plain(data, rows) {
    // HTML-Tabelle extrahieren
  _.map(data, item => {
    if (!item) {
      return;
    }

    if (_.isArray(item)) {
      _.map(item, x => report2plain([x], rows));
      return;
    }

    if (item.type == "tr") {
      rows.push([]);
      if (!_.isEmpty(item.props.children)) {
        if (_.isArray(item.props.children)) {
          _.map(item.props.children, child => report2plain([child], rows));
        } else {
          rows[rows.length - 1].push(item.props.children);
        }
      }
    } else if (item.type == "td") {
      let value = isReactElement(item) ? getInnerText(item) : item;

      if (item.props.className && item.props.className.indexOf("betrag") >= 0) {
        if (_.isString(value) && !_.isEmpty(value)) {
            /*
             * PBP-2395 formatiertes Währungsfeld in Export mitnehmen, aber Währung an den Anfang hängen
             * // Währungskennzeichen weglassen
             * value = value.replace(/[^0-9\.,-]+/g, "");
             */
          const negative = value.startsWith("-");
            // Währungskennzeichen und Tausendertrennzeichen weglassen
          value = value.replace(/[^0-9,-]+/g, "");
          value = `${ negative ? "-" : "" }\u20AC${ negative ? value.slice(1, value.length) : value }`;
        }
      }

      rows[rows.length - 1].push(value);
    } else if (item.type == "th") {
      let value = item;
      value = isReactElement(value) ? getInnerText(value) : value;
      rows[rows.length - 1].push(value);
    }
  });
}


